import { renderObjectIcon } from '../utils/icons';
import BusinessProcessBase from './BusinessProcessBase';

class ShapeBusinessProcessActivity extends BusinessProcessBase {
  static defaultWidth() {
    return 175;
  }

  static defaultHeight() {
    return 140;
  }

  uniformScaling = false;

  hasEmbeddedText() {
    return true;
  }

  // same as ShapeRoundRect, but with uniform radius
  static pathString() {
    const r = 0.15;

    return `
      M -${0.5 - r} -0.5
      L ${0.5 - r} -0.5
      R ${r} 0 1
      L 0.5 ${0.5 - r}
      R ${r} 1 1
      L -${0.5 - r} 0.5
      R ${r} 2 1
      L -0.5 -${0.5 - r}
      R ${r} 3 1
      Z
    `;
  }

  getObjectProperties() {
    return {
      ...super.getObjectProperties(),
      minScaleLimit: 0.5,
    };
  }

  render(ctx: CanvasRenderingContext2D) {
    super.render(ctx);

    // Render the icon in the top left
    if (this.icon) {
      renderObjectIcon(ctx, this.icon, 40, [5, 5], this.fabricObject);
    }
  }
}

export default ShapeBusinessProcessActivity;
